export default __webpack_public_path__ + "static/media/telus.2d394f0f.png";